import SubscriptionProducts from './containers/SubscriptionProducts';

export default SubscriptionProducts;
